<!--
 * @Descripttion: 
 * @Author: liang
 * @Date: 2020-09-11 17:22:16
 * @LastEditors: liang
 * @LastEditTime: 2020-09-30 11:53:04
-->
<template>
  <div>
    <!-- <div id="secondnav">
      <div class="secondnav">
        <div class="title">人才招聘</div>
      </div>
    </div> -->
    <div class="content">
      <div class="name">招贤纳士</div>
      <div class="accordion">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item
            :title="item.title"
            :name="index"
            v-for="(item, index) in datalist"
            :key="index"
          >
            <div v-html="item.content"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 0,
      datalist: []
    };
  },
  created() {
    this.getinfo();
  },
  methods: {
    getinfo() {
      this.$get("/website/joinPage?menuCode=websiteJoinus").then(res => {
        this.datalist = res.data.list;
      });
    }
  }
};
</script>
<style scoped>
.name {
  font-size: 28px;
  text-align: center;
  padding: 30px 0 50px 0;
  font-weight: bold;
}
.accordion /deep/.el-collapse-item__header {
  font-weight: bold;
  font-size: 18px;
}
.accordion /deep/.el-collapse-item__wrap {
  padding: 20px 20px 0 20px;
  border-top: 1px solid #eee;
}
.content {
  width: 1160px;
  margin: 0 auto;
  padding: 20px;
  float: none;
  background: #f5fafe;
  margin-top: 20px;
}
/deep/.content p {
  line-height: 18px;
  font-size: 14px;
}
.accordion {
  background: #fff;
  padding: 0 20px;
}
#secondnav {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid rgb(138, 159, 197);
  box-sizing: border-box;
  height: 80px;
}
.secondnav {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.secondnav .title {
  font-weight: bold;
  float: left;
  padding: 0 25px;
  line-height: 75px;
  display: inline-block;
  font-size: 16px;
  border-bottom: 5px solid rgb(30, 69, 141);
  box-sizing: border-box;
}

.secondnav .mbx {
  float: left;
  padding-top: 33px;
  padding-left: 50px;
}
</style>
